/** One qualified view per mounted placement; fast interactions are handled by the link. */
export function observeSupportImpression(
  element: Element,
  canTrack: () => boolean,
  onImpression: () => void,
): () => void {
  if (typeof IntersectionObserver === 'undefined') return () => undefined
  let timer: ReturnType<typeof setTimeout> | undefined
  let inView = false
  let fired = false
  const cancel = () => { clearTimeout(timer); timer = undefined }
  const schedule = () => {
    cancel()
    if (fired || !inView || document.visibilityState !== 'visible' || !canTrack()) return
    timer = setTimeout(() => {
      if (!canTrack() || document.visibilityState !== 'visible') return
      fired = true
      onImpression()
      observer.disconnect()
    }, 1000)
  }
  const observer = new IntersectionObserver(([entry]) => {
    inView = entry.isIntersecting && entry.intersectionRatio >= 0.5
    schedule()
  }, { threshold: [0, 0.5] })
  observer.observe(element)
  document.addEventListener('visibilitychange', schedule)
  return () => { cancel(); observer.disconnect(); document.removeEventListener('visibilitychange', schedule) }
}
